module.exports = __webpack_public_path__ + "media/images/farringdon-2d252e13.png";